import React, {Component} from "react";
import {
  Panel,
  Button,
  ButtonGroup,
  Table
}                         from "react-bootstrap";
import ReactHighcharts    from "react-highcharts";

export default class EventReport extends Component {
  constructor (props) {
    super(props);

    this.state = {
      isLoadingData: false,
      customEventEventNameReport: null,
      customEventReports: [],
      reportType: "GRAPH",
      sorting: {
        column: "value",
        sort: "ascending"
      }
    };

    this.getData = this.getData.bind(this);
  }

  getData () {
    let {
      match
    } = this.props;

    let {
      id
    } = match.params;

    this.setState({
      isLoadingData: true
    });

    let customEventEventNameReportQuery = new Parse.Query("CustomEventEventNameReport"),
        customEventReportQuery = new Parse.Query("CustomEventReport");

    customEventEventNameReportQuery.get(id)
    .then((customEventEventNameReport) => {
      customEventReportQuery.equalTo("eventName", customEventEventNameReport.get("eventName"));
      customEventReportQuery.ascending("value");

      return Promise.all([
        customEventEventNameReport,
        customEventReportQuery.find()
      ]);
    })
    .then(([ customEventEventNameReport, customEventReports]) => {
      this.setState({
        isLoadingData: false,
        customEventEventNameReport,
        customEventReports
      });
    })
    .catch((err) => {
      console.log("error: ", err);
      this.setState({
        isLoadingData: false,
        customEventEventNameReport: [],
        customEventReports: []
      });
    });
  }

  render () {
    let {
      isLoadingData,
      customEventEventNameReport,
      customEventReports,
      reportType,
      sorting
    } = this.state;

    let renderGraph = [],
        itemPerGraph = 10;

    for (let i = 0; i < Math.ceil(customEventReports.length/itemPerGraph); i++) {
      renderGraph.push(
        <ReactHighcharts
          config={
            {
              chart: {
                type: "bar"
              },
              title: {
                text: null
              },
              subtitle: {
                text: null
              },
              xAxis: {
                type: "category"
              },
              yAxis: {
                min: 0,
                title: {
                  text: "Total"
                }
              },
              legend: {
                enabled: false
              },
              tooltip: {
                pointFormat: 'Total: <b>{point.y}</b>'
              },
              series: [
                {
                  name: customEventEventNameReport ? customEventEventNameReport.get("eventName") : "",
                  data: customEventReports.map((item) => ({
                    name: item.get("value") ? item.get("value") : "undefined",
                    y: item.get("total")
                  }))
                  .sort((a, b) => {
                    return b.y - a.y;
                  })
                  .slice((i)*itemPerGraph, (i+1)*itemPerGraph)
                }
              ]
            }
          }/>
      );
    }

    let renderSortIcon = (assingedColumn = "value") => {
      let {
        column,
        sort
      } = sorting;

      let iconName = "",
          isAscending = sort.toUpperCase() === "ASCENDING" ? true : false;

      iconName = isAscending ? `sort-${assingedColumn === "value" ? "alpha" : "numeric"}-asc` : `sort-${assingedColumn === "value" ? "alpha" : "numeric"}-desc`;

      if (column === assingedColumn) {
        return <i className={`fa fa-${iconName}`}/>
      } else {
        return "";
      }
    };
    return (
      <div>
        <Panel>
          {isLoadingData ? (
            <Panel.Body style={{ textAlign: "center" }}>
              <i
                className="fa fa-spinner fa-3x fa-spin"
                />
            </Panel.Body>
          ) : (
            <Panel.Body>
              <h3
                style={{
                  display: "inline-block",
                  marginTop: 0
                }}
                >
                {customEventEventNameReport ? customEventEventNameReport.get("eventName") : "" } Event
              </h3>
              <ButtonGroup
                style={{ float: "right" }}
                >
                {[ "Graph", "Table" ].map((item, index) => (
                  <Button
                    active={item.toUpperCase() === reportType}
                    onClick={() => {
                      this.setState({ reportType: item.toUpperCase() });
                    }}
                    >
                    {item}
                  </Button>
                ))}
              </ButtonGroup>
              <br/>
              <br/>
              {reportType === "GRAPH" ? (
                renderGraph
              ) : (
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <td>
                        <a
                          href="javascript:void(0)"
                          onClick={() => {
                            let isAscending = sorting.sort.toUpperCase() === "ASCENDING";

                            let clone = customEventReports.map((item) => item).sort((a, b) => {
                              let item1 = a.get("value") || "",
                                  item2 = b.get("value") || "";

                              if (item1 < item2) {
                                return isAscending ? 1 : -1;
                              } else if (item1 > item2) {
                                return isAscending ? -1 :1;
                              }
                              return 0;
                            });

                            this.setState({
                              customEventReports: clone,
                              sorting: {
                                column: "value",
                                sort: isAscending ? "descending" : "ascending"
                              }
                            });
                          }}
                          >
                          Value {renderSortIcon("value")}
                        </a>
                      </td>
                      <td>
                        <a
                          href="javascript:void(0)"
                          onClick={() => {
                            let isAscending = sorting.sort.toUpperCase() === "ASCENDING";

                            let clone = customEventReports.map((item) => item).sort((a, b) => {
                              let item1 = a.get("total") || 0,
                                  item2 = b.get("total") || 0;

                              return isAscending ? (item2 - item1) : (item1 - item2);
                            });

                            this.setState({
                              customEventReports: clone,
                              sorting: {
                                column: "total",
                                sort: isAscending ? "descending" : "ascending"
                              }
                            });
                          }}
                          >
                          Total {renderSortIcon("total")}
                        </a>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {customEventReports.map((item, index) => (
                      <tr>
                        <td>{item.get("value")}</td>
                        <td>{item.get("total")}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Panel.Body>
          )}
        </Panel>
      </div>
    );
  }

  componentDidMount () {
    this.getData();
  }
}



// WEBPACK FOOTER //
// ./components/Report/EventReport.js